// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lawyer_picture_components-module__picture--N9_Cy{display:block;height:120px;width:120px;-webkit-background-size:cover;-moz-background-size:cover;background-size:cover;position:relative;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;margin:auto}.lawyer_picture_components-module__empty--2xneA{background-color:#e7ebef}\n", ""]);
// Exports
exports.locals = {
	"picture": "lawyer_picture_components-module__picture--N9_Cy",
	"empty": "lawyer_picture_components-module__empty--2xneA"
};
module.exports = exports;
